export default __webpack_public_path__ + "static/media/alb.7670ebc3.svg";